import React from "react";
import { Menu, PopoverOrigin, SxProps } from "@mui/material";
import styled from "styled-components";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";

import { DropdownWhiteIcon } from "../Icon/DropdownWhiteIcon";
import { WhiteStyledButton } from "./WhiteStyledButton";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

interface IDropdownMenuItem {
    renderUI: () => JSX.Element | null;
}

interface DropdownMenuProps {
    title: JSX.Element | string;
    id?: string;
    items: IDropdownMenuItem[];
    ahchorOrigin?: PopoverOrigin;
    transformOrigin?: PopoverOrigin;
    direction?: "down" | "right";
    sx?: SxProps;
}

export function UIDropdownMenu(props: DropdownMenuProps) {
    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <WhiteStyledButton
                aria-controls={props.id || "dropdown_menu"}
                aria-haspopup="true"
                onClick={handleClick}
                endIcon={props.direction === "right" ? <ArrowRightIcon /> : <DropdownWhiteIcon />}
            >
                {props.title}
            </WhiteStyledButton>
            <StyledMenu
                sx={props.sx}
                id={props.id}
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={
                    props.ahchorOrigin || {
                        vertical: "bottom",
                        horizontal: "center",
                    }
                }
                transformOrigin={
                    props.transformOrigin || {
                        vertical: "top",
                        horizontal: "center",
                    }
                }
            >
                <div>
                    {props.items.map((item, idx) => (
                        <React.Fragment key={idx}>{item.renderUI()}</React.Fragment>
                    ))}
                </div>
            </StyledMenu>
        </>
    );
}

export const StyledMenu = styled(Menu)`
    && {
        .MuiMenu-list {
            min-width: 100px;

            > div {
                display: flex;
                flex-direction: column;

                .MuiButtonBase-root {
                    justify-content: space-between;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 17px;

                    color: ${UIStyleConstants.BLUE_COLOR};
                }
            }
        }
    }
`;
